import { render, staticRenderFns } from "./DistributorProfile.vue?vue&type=template&id=1c15c61f"
import script from "./DistributorProfile.vue?vue&type=script&lang=js"
export * from "./DistributorProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports